import React from 'react';
import Skeleton from './Skeleton';

interface AISkeletonLoaderProps {
  loading: boolean;
}

const AISkeletonLoader: React.FC<AISkeletonLoaderProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="mx-3 my-0 relative h-15">
      <Skeleton width={120} height={3} top={0} left={0} />
      <Skeleton width={140} height={3} top={6} left={0} />
      <Skeleton width={80} height={3} top={12} left={0} />
    </div>
  );
};

export default AISkeletonLoader;
